export * as modalOverlayStyleConfigs from './style-configs';
export { ModalOverlay } from './modal-overlay';
export type { ModalOverlayProps } from './types';
